import React, {useState, useCallback, useEffect} from 'react';
import {message, Upload, Button} from 'antd'
import "./index.scss";
import {LoadingOutlined, PlusOutlined, UploadOutlined} from "@ant-design/icons";
import {getOssSecret,getYunYingOssSecret, ossRequest,ossRequest2} from "./oss";

const ImgTypes = ['head','cover','picture', 'xiaozhao']

/**
 * @param type  1: avatar   2: cover    3: pic  4: xiaozhao
 * @returns {JSX.Element}
 * @constructor
 */
export default function Uploader({onResult, type = 1,children, style}) {
    const [loading, setLoading] = useState(false);
    const beforeUpload = useCallback((file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('只能上传 JPG/PNG 图片!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('图片大小必须小于2MB!');
        }
        return isJpgOrPng && isLt2M;
    })

    return (
        <Upload
            name="avatar"
            style={style||{width: 200, height: 120}}
            listType="picture-card"
            className={type === 2 ? "cover-uploader" : "avatar-uploader"}
            showUploadList={false}
            accept="image/png, image/jpeg"
            beforeUpload={beforeUpload}
            onStart={()=>{
                setLoading(true);
            }}
            onProgress={ ({ percent })=>{
                //console.info(percent)
            }}
            onError={ (Error, body)=>{
                setLoading(false);
            }}
            onSuccess={ (body)=>{
                setLoading(false);
            }}
            customRequest={(file)=>{
                setLoading(true);
                getOssSecret({ dir: ImgTypes[type-1] }).then(res => {
                    ossRequest(res.info, file).then(url => {
                        setLoading(false);
                        onResult && onResult(url)
                    })
                })
            }}
        >
            <div>
                {loading ? <LoadingOutlined/> : !children&&<PlusOutlined/>}
                {children?children:<div style={{marginTop: 8}}>上传</div>}
            </div>
        </Upload>
    );
}

export function FileUploader({onResult, type='video'}) {
    const [loading, setLoading] = useState(false);
    const [percent, setPercent] = useState(0)

    useEffect(()=>{
        setPercent(0)
    },[])

    const onProgress = useCallback((e) => {
        setPercent(e.percent)
    })
    const customRequest = (file)=>{
        setLoading(true);
        getOssSecret({ dir: type||'video' }).then(res => {
            ossRequest(res.info, file).then(url => {
                setLoading(false);
                onResult && onResult(url)
            })
        })
    }
    const beforeFileUpload = useCallback((file) => {
        const isMp4 = file.type === 'video/mp4';
        if (!isMp4) {
            message.error('视频只支持MP4格式!');
        }
        const isLimitSize = file.size / 1024 / 1024 < 1024;
        if (!isLimitSize) {
            message.error('视频大小必须小于1G!');
        }
        return isMp4 && isLimitSize;
    })
    return <Upload
        name='file'
        className="file-uploader"
        accept="video/mp4"
        showUploadList={false}
        beforeUpload={beforeFileUpload}
        customRequest={customRequest}
        onProgress={onProgress}
    >
        <Button className="overflow" icon={loading ? <LoadingOutlined/> :<UploadOutlined/>}>
            {loading ? '上传中...' : '上传文件'}
            <div className='progress' style={{width:percent+'%'}}></div>
        </Button>
    </Upload>
}

export function PDFUploader({onResult, type='video'}) {
    const [loading, setLoading] = useState(false);
    const [percent, setPercent] = useState(0)

    useEffect(()=>{
        setPercent(0)
    },[])

    const onProgress = useCallback((e) => {
        setPercent(e.percent)
    })
    const customRequest = (file)=>{
        setLoading(true);
        getOssSecret({ dir: type }).then(res => {
            ossRequest(res.info, file).then(url => {
                setLoading(false);
                onResult && onResult(url)
            })
        })
    }
    const beforeFileUpload = useCallback((file) => {
        const isPdf = file.type === 'application/pdf';
        if (!isPdf) {
            message.error('视频只支持PDF格式!');
        }
        const isLimitSize = file.size / 1024 / 1024 < 1024;
        if (!isLimitSize) {
            message.error('视频大小必须小于1G!');
        }
        return isPdf && isLimitSize;
    })
    return <Upload
        name='file'
        className="file-uploader"
        accept="application/pdf"
        showUploadList={false}
        beforeUpload={beforeFileUpload}
        customRequest={customRequest}
        onProgress={onProgress}
    >
        <Button className="overflow" icon={loading ? <LoadingOutlined/> :<UploadOutlined/>}>
            {loading ? '上传中...' : '上传文件'}
            <div className='progress' style={{width:percent+'%'}}></div>
        </Button>
    </Upload>
}

export function YunyingUploader({onResult, type="00",children}) {
    const [loading, setLoading] = useState(false);
    const [fileList,setFileList] = useState([]);
    const beforeUpload = useCallback((file) => {
        console.log(file)
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('只能上传 JPG/PNG 图片!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('图片大小必须小于2MB!');
        }
        return isJpgOrPng && isLt2M;
    })

    return (
        <Upload
            name="logo"
            multiple={true}
            showUploadList={false}
            accept="image/png, image/jpeg"
            beforeUpload={beforeUpload}
            fileList={fileList}
            onStart={()=>{
                setLoading(true);
            }}
            onProgress={ ({ percent })=>{
                // console.info(percent)
            }}
            onError={ (Error, body)=>{
                setLoading(false);
            }}
            onSuccess={ (body)=>{
                setLoading(false);
            }}

            onChange={(file)=>{
                setFileList(file.fileList)
            }}
            customRequest={(file)=>{
                setLoading(true);
                getYunYingOssSecret({ dir: type}).then(res => {
                    ossRequest2(res.info, file).then(url => {
                        setLoading(false);
                        onResult && onResult(url,fileList.length)
                        setFileList([])
                    })
                })
            }}
        >
            <div>
                {/* {loading ? <LoadingOutlined/> : !children&&<PlusOutlined/>} */}
                {children?children:<div style={{marginTop: 8}}>上传</div>}
            </div>
        </Upload>
    );
}
